<ng-container *ngIf="deviceService.isDesktop(); else mobileCard" [ngTemplateOutlet]="card"></ng-container>

<ng-template #card>
  <article class="service-card wide2"
           itemscope itemtype="https://schema.org/Article">

    <div class="content">
      <div class="card-cover"></div>

      <div class="cover-wrap">
        <div class="type" [ngClass]="eUserServiceType[service.type]">{{ typeLabel(service.type) | translate }}</div>
        <on-ui-cover [cover]="cover"></on-ui-cover>
      </div>

      <a [routerLink]="userServiceRoute" [attr.title]="service.title" class="info-block">
        <div>
          <div class="subject">{{ service.subject.title }}</div>
          <div class="title">{{ service.title | striptags }}</div>
          <ng-container
            *ngTemplateOutlet="secondInfo;  context: { service: service, options: service.options }"></ng-container>
        </div>

        <div class="footer-block">
          <ng-container *ngTemplateOutlet="priceBlock"></ng-container>
          <ng-container *ngTemplateOutlet="statusBlock"></ng-container>
        </div>
      </a>

      <div class="actions">
        <ng-container *ngTemplateOutlet="actionsRef"></ng-container>
      </div>
    </div>

    <ng-template [ngIf]="isOpenStats">
      <ng-container *ngTemplateOutlet="statsRef"></ng-container>
    </ng-template>

  </article>
</ng-template>

<ng-template #mobileCard>
  <article class="service-card-mobile">
    <div class="details">
      <div class="cover-wrap">
        <div class="type" [ngClass]="eUserServiceType[service.type]">{{ typeLabel(service.type) | translate }}</div>
        <on-ui-cover [cover]="cover"></on-ui-cover>
      </div>
      <a [routerLink]="userServiceRoute" [attr.title]="service.title" class="title-wrap">
        <div class="subject">{{ service.subject.title }}</div>
        <div class="title">{{ service.title | striptags }}</div>
      </a>
    </div>
    <div>
      <ng-container
        *ngTemplateOutlet="secondInfo;  context: { service: service, options: service.options }"></ng-container>
      <div class="footer-block">
        <ng-container *ngTemplateOutlet="priceBlock"></ng-container>
        <ng-container *ngTemplateOutlet="statusBlock"></ng-container>
      </div>
    </div>

    <div class="footer">
      <div class="actions">
        <ng-container *ngTemplateOutlet="actionsRef"></ng-container>
      </div>
    </div>

    <ng-template [ngIf]="isOpenStats">
      <ng-container *ngTemplateOutlet="statsRef"></ng-container>
    </ng-template>

  </article>
</ng-template>

<ng-template #priceBlock>
  <div class="price-block">
    <div class="current-price">
      <span class="price">{{ getFormattedAmount() | async }}</span>
      <span class="period">{{ labelPeriod() | translate }}</span>
    </div>
  </div>
</ng-template>

<ng-template #secondInfo
             let-service="service"
             let-options="options">
  <div class="second-info">
    <div class="row">
      <span class="text">
        {{ participants() | translate }}
      </span>
      <div class="separator"></div>
      <ng-template [ngIf]="isRegularClass" [ngIfElse]="otherServices">
        <span class="text">
          {{ 'teacher-card.stats.classes' | translate}} {{ 'event-calendar.ongoing' | translate }}
        </span>
        <div class="separator"></div>
      </ng-template>
      <ng-template #otherServices>
        <ng-template [ngIf]="options?.meetings_limit">
          <span class="text">
            {{ 'teacher-card.stats.classes' | translate}} {{ options?.meetings_limit }}
          </span>
          <div class="separator"></div>
        </ng-template>
      </ng-template>
<!--      <span class="text">{{ 'library.user-service-card.entry-level' | translate }}</span>-->
<!--      <div class="separator"></div>-->
      <span class="text">
        {{ 'user-service-form-3.fields.label9' | translate }} {{ options?.age_from }}-{{ formatAge(options?.age_to) }}</span>
    </div>
    <div class="row">
      <ng-template [ngIf]="weekdaysToString(options?.weekdays)">
        <span class="text">{{ weekdaysToString(options?.weekdays) }}</span>
        <div class="separator"></div>
      </ng-template>
      <span class="text">{{ service?.duration }} {{ 'library.user-service-card.min' | translate }}</span>
      <ng-template [ngIf]="false">
        <div class="separator"></div>
        <span class="text">10:00 - 11:00</span>
      </ng-template>
    </div>
  </div>
</ng-template>

<ng-template #statusBlock>
  <div class="status" *ngIf="moderationStatus.label || showReasonMessage">
    <div class="status-block status-block__{{moderationStatus.value}}" *ngIf="moderationStatus.label">
      {{ moderationStatus.label | translate }}
    </div>
    <div class="reason-icon" *ngIf="showReasonMessage">
      <app-icon width="15" height="15" icon="question-service"></app-icon>
      <div class="reason-text">
        <p class="label">Причина:</p>
        <p class="text">{{service.moderation_message}}</p>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #actionsRef>
  <span class="action"
        data-test="open-card"
        (click)="onOpenCardInModal()">{{ 'my-library.cards-actions.view' | translate }}</span>
  <span class="action" *ngIf="service.can.edit"
        data-test="edit-card"
        (click)="onEdit()">{{ 'my-library.cards-actions.edit' | translate }}</span>
  <span class="action" *ngIf="service.can.restore"
        data-test="restore-card"
        (click)="onRestore()">{{ 'my-library.cards-actions.restore' | translate }}</span>
  <span class="action" *ngIf="service.can.archive"
        data-test="archive-card"
        (click)="onOpenAlert()">{{ 'user-profile.service-card.remove' | translate }}</span>
  <span class="action" *ngIf="isSchoolClasses"
        data-test="school-stats"
        (click)="toggleSchoolStats()">{{ (isOpenStats ? 'my-library.cards-actions.hide-stats' : 'my-library.cards-actions.show-stats') | translate }}</span>
</ng-template>

<ng-template #statsRef>
  <div class="expandable">
    <div class="table-header">
      <span>{{ 'library.user-service-card.stats.tutor' | translate }}</span>
      <span>{{ 'library.user-service-card.stats.rating' | translate }}</span>
      <span>{{ 'library.user-service-card.stats.classes' | translate }}</span>
    </div>

    <div class="table-body">
      <div *ngFor="let teacher of teachers; trackBy: trackByFn" class="stat-row">
        <div class="teacher">
          <div class="avatar-wrap">
            <on-ui-cover [cover]="teacherAvatar(teacher)"></on-ui-cover>
          </div>
          <span class="full-name">{{ teacherAvatar(teacher).title }}</span>
        </div>
        <div class="rating">
          <app-rating [stats]="teacher?.stats"></app-rating>
        </div>
        <span class="meetings-count">{{ teacher?.stats?.meetings_count || 0 }}</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template [ngIf]="alertOpened">
  <app-alert type="error">
    <ng-container alert-title>{{ 'user-profile.service-card.alert.title' | translate }}</ng-container>
    <ng-container alert-body>{{ 'user-profile.service-card.alert.text' | translate }}</ng-container>
    <ng-container alert-buttons>
      <on-ui-button label="user-profile.service-card.alert.close"
                    class="poutline"
                    data-test="cancel"
                    (onclick)="alertOpened = false">
      </on-ui-button>
      <on-ui-button label="user-profile.service-card.alert.remove"
                    class="danger"
                    data-test="remove"
                    (onclick)="onRemove()">
      </on-ui-button>
    </ng-container>
  </app-alert>
</ng-template>
